//设置缓存
export function localStorageSet(name, data, expireTime = 30000) {
    const obj = {
        data,
        expire: new Date().getTime() + 1000 * 60 * expireTime
    }
    localStorage.setItem(name, JSON.stringify(obj))
}

//读取缓存
export function localStorageGet(name) {
    const storage = localStorage.getItem(name)
    const time = new Date().getTime()
    let result = null
    if (storage) {
        const obj = JSON.parse(storage)
        if (time < obj.expire) {
            result = obj.data
        } else {
            localStorage.removeItem(name)
        }
    }
    return result;
}

export function removeItem(name) {
    localStorage.removeItem(name)
}